module.exports = __webpack_public_path__ + "img/sort_down.b12ce509.png";